import { ScientificAnalysisEntityFilters } from '@/modules/scientific-analysis-module/shared/scientific-analysis.models'
import { Nullable } from '@/shared/types/app.types'
import { ScientificAnalysisFilterEntityType, ScientificAnalysisSaveResponse, ScientificAnalysisSearchEntityType } from '../../services/scientific-analysis-dtos'
import { CommonLaboratoryResponse } from '@/api/services/common.dto'

export const SCIENTIFIC_ANALYSIS_NONE_SELECTED_FILTER: number = -1

export interface ScientificAnalysisEntityFiltersVO {
    dto: ScientificAnalysisEntityFilters
    hide: boolean
    selectedFilter: number
}

export interface ScientificAnalysisSearchPanelState {
    laboratories: CommonLaboratoryResponse[]
    loadedAnalysisDTO: Nullable<ScientificAnalysisSaveResponse>
    searchEntities: ScientificAnalysisSearchEntityType[]
    filterEntities: ScientificAnalysisFilterEntityType[]
    selectedFilterEntity: Nullable<ScientificAnalysisFilterEntityType>
    entityFilters: ScientificAnalysisEntityFiltersVO[]
}
export const initialScientificAnalysisSearchPanelState =
    (): ScientificAnalysisSearchPanelState => ({
        laboratories: [],
        loadedAnalysisDTO: null,
        searchEntities: [],
        filterEntities: [],
        selectedFilterEntity: null,
        entityFilters: []
    })

export const SEARCH_EVENT_NAME: string = 'searchEvent'
